export default __webpack_public_path__ + "1b31dc54a76e56f304eb4dce8b683f31.png";